<template>
  <div class="mobile-menu block lg:hidden">
    <div class="mobile-menu__links">
      <router-link
        class="mobile-menu__link mobile-menu__link--homeworks homework-card"
        v-if="isHomeworkCardVisible"
        :to="{name: 'Main.Homeworks'}"
        active-class="active homeworks-active"
      >
        <img class="homework-card" src="@/assets/images/icons/homeworks.svg" />
      </router-link>
      <router-link
        v-if="isAttendancesCardVisible"
        class="mobile-menu__link mobile-menu__link--attendances attendances-card"
        :to="{name: 'Main.Attendances'}"
        exact-active-class="active attendances-active"
      >
        <img class="attendances-card" src="@/assets/images/icons/attendances.svg" />
      </router-link>
      <router-link
        class="mobile-menu__link mobile-menu__link--grades grades-card"
        v-if="isGradesCardVisible"
        :to="{name: 'Main.Grades'}"
        exact-active-class="active grades-active"
      >
        <img class="grades-card" src="@/assets/images/icons/grades.svg" />
      </router-link>
      <router-link
        v-if="isMaterialsCardVisible"
        class="mobile-menu__link mobile-menu__link--materials materials-card"
        exact-active-class="active materials-active"
        :to="{ name: 'Main.OnlineMaterials', query: { time: Date.now() } }"
      >
        <img class="materials-card" src="@/assets/images/icons/materials.svg" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'MobileMenu',

  computed: {
    ...mapState('students', ['student']),
    ...mapGetters('auth', ['isFullAccess', 'isDemoAccess', 'isEmptyAccess', 'isAgentProfile', 'isAdditionalAccessProfile']),

    isHomeworkCardVisible() {
      // eslint-disable-next-line no-prototype-builtins
      return (this.isEmptyAccess && !this.isAgentProfile && !this.isAdditionalAccessProfile) || (this.isFullAccess && (this.student?.group?.hasOwnProperty('hasHomeworks') && this.student.group.hasHomeworks));
    },

    isAttendancesCardVisible() {
      return !this.isDemoAccess && !this.isAgentProfile && !this.isAdditionalAccessProfile;
    },

    isGradesCardVisible() {
      // eslint-disable-next-line no-prototype-builtins
      return (this.isEmptyAccess && !this.isAgentProfile && !this.isAdditionalAccessProfile) || (this.isFullAccess && (this.student?.group?.hasOwnProperty('hasGrades') && this.student.group.hasGrades));
    },

    isMaterialsCardVisible() {
      if (this.isAgentProfile || this.isAdditionalAccessProfile) return true;
      const exception = 'brak';
      const screenTitle = this.student?.group?.realizationEdTechLinks;
      if (screenTitle && screenTitle === exception) return false;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-menu {
  @apply fixed w-full mx-auto text-center z-20;
  right: 0;
  left: 0;
  bottom: 0;
  box-shadow: 0px -2px 14px -5px rgba(0,0,0,0.31);
  &__links {
    @apply flex justify-between bg-white px-3;
    img {
      @apply h-10;
    }
    a {
      @apply mx-auto py-3 z-10;
      &.active {
        @apply relative;
        &::before {
          @apply absolute rounded-full h-10 w-10;
          content: "";
          top: 16px;
          z-index: -1;
        }
      }
      &.homeworks-active{
        &::before {
          top: 21px;
          width: 29px;
          height: 29px;
          left: 1px;
          background: #88c1e4;
        }
      }
      &.attendances-active{
        &::before {
          top: 18px;
          width: 30px;
          height: 30px;
          left: -4px;
          background: #f6b1c0;
        }
      }
      &.grades-active {
        &::before {
          top: 19px;
          height: 27px;
          width: 27px;
          left: -2px;
          background: #f59e00;
        }
      }
      &.materials-active {
        &::before {
          left: 0px;
          top: 21px;
          height: 27px;
          width: 27px;
          background: #EE4023;
          opacity: .8;
        }
      }

    }
  }
  &__link{
    &--homeworks{
      width: 29px;
    }
    &--attendances{
      width: 23px;
    }
    &--grades{
      width: 23px;
    }
    &--materials{
      width: 24px;
    }
  }
}
</style>
